import { render, staticRenderFns } from "./association-confirm-order.vue?vue&type=template&id=84b3d7e2&scoped=true&"
import script from "./association-confirm-order.vue?vue&type=script&lang=js&"
export * from "./association-confirm-order.vue?vue&type=script&lang=js&"
import style0 from "./association-confirm-order.vue?vue&type=style&index=0&id=84b3d7e2&prod&lang=scss&"
import style1 from "./association-confirm-order.vue?vue&type=style&index=1&id=84b3d7e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b3d7e2",
  null
  
)

export default component.exports